<template>
    <div>
        <my-form 
        class="form-page" 
        v-model="form" 
        table 
        label-width="180px" 
        @cancle="cancleHandler" 
        @submit="fsave">

            <my-form-item-group title="项目信息">
                <el-form-item 
                label="交易中心"
                prop="ext5"
                :rules="newRule('交易中心', 'required')"
                class="table-full-row">
                    <my-select
                    class="form-item_half"
                    v-model="form.ext4"
                    :data="model.cityList"
                    :props="{value:'CITYID',label:'CITYNAME'}"
                    @select="getJyzx()"
                    placeholder="选择地市">
                    </my-select>
                    
                    <my-select
                    class="form-item_half"
                    v-model="form.ext5"
                    :data="jyzxList"
                    :props="{value:'JYZXCODE',label:'JYZXNAME'}"
                    placeholder="选择交易中心"
                    :disabled="!form.ext4">
                    </my-select>
                </el-form-item>

                <el-form-item 
                label="项目名称" 
                prop="zbproname"
                :rules="newRule('项目名称', 'required')"
                class="table-full-row">
                    <el-input v-model="form.zbproname" maxlength="150"></el-input>
                </el-form-item>
                <el-form-item
                    prop="izyfzb"
                    label="是否属于依法招标"
                    :class="[form.ext4 === '130500' ? '' : 'table-full-row']"
                    :rules="newRule('是否属于依法招标', 'required')">
                    <my-radio
                        v-model="form.izyfzb"
                        :data="[{key:'1', value:'是'}, {key:'0', value:'否'}]">
                    </my-radio>
                </el-form-item>
                <el-form-item
                    label="监督部门"
                    v-if="form.ext4 === '130500'"
                    prop="supervisiondepartmentcode"
                    :rules="newRule('监督部门', 'required')">
                    <my-select
                        style="width: 100%;"
                        v-model="form.supervisiondepartmentcode"
                        :data="xtjddw"
                        :props="{value:'supervision_Code',label:'supervision_Name'}"
                        @select="jdChange"
                        placeholder="选择监督部门">
                    </my-select>
                    <my-tag v-if="jdxx" type="danger">
                        {{jdxx}}
                    </my-tag>
                </el-form-item>

                <el-form-item 
                prop="prousername"
                :rules="newRule('代理机构项目负责人', 'required')"
                label="代理机构项目负责人">
                    <el-input v-model="form.prousername" maxlength="50" show-word-limit></el-input>
                </el-form-item>

                <el-form-item 
                prop="e_lxrphone2"
                :rules="newRule('项目负责人手机号码', 'required', 'mobile')"
                label="项目负责人手机号码">
                    <el-input v-model="form.e_lxrphone2"></el-input>
                </el-form-item>

                <el-form-item 
                label="项目所属行业" 
                prop="prohyflcode" 
                :rules="newRule('项目所属行业', 'required')">
                    <cascader-hy
                    v-model="form.prohyflcode"
                    2way="text"
                    @hysorname="hysorname"
                    :text.sync="form.prohyflname"
                    placeholder="选择项目所属行业">
                    </cascader-hy>
                </el-form-item>

                <el-form-item 
                label="项目预算" 
                prop="e_zbgse" 
                :rules="newRule('项目预算', 'required','number')">
                    <el-input-number 
                    v-model.number="form.e_zbgse" 
                    :min="0"
                    :max="1e+18"
                    size="medium"
                    style="width:250px">
                    </el-input-number>万元 人民币
                </el-form-item>

                <el-form-item 
                label="谈判文件获取方式" 
                v-if="form.type === '3'"
                prop="zbfscode" 
                :rules="newRule('谈判文件获取方式', 'required')">
                    <my-radio
                    :props="{label:'dicname',value:'diccode'}"
                    v-model="form.zbfscode"
                    :data="model.zhaobiaofangshi"
                    2way="dicname"
                    :dicname.sync="form.zbfsname">
                    </my-radio>
                </el-form-item>
                
                <el-form-item 
                label="磋商文件获取方式" 
                v-if="form.type === '6'"
                prop="zbfscode" 
                :rules="newRule('谈判文件获取方式', 'required')">
                    <my-radio
                    :props="{label:'dicname',value:'diccode'}"
                    v-model="form.zbfscode"
                    :data="model.zhaobiaofangshi"
                    2way="dicname"
                    :dicname.sync="form.zbfsname">
                    </my-radio>
                </el-form-item>

                <el-form-item
                prop="investtype" 
                label="投资主体性质"
                :rules="newRule('投资主体性质', 'required')">
                    <my-radio
                    v-model="form.investtype"
                    :data="[{key:'10', value:'政府投资'}, {key:'20', value:'企业投资'}, {key:'30', value:'其他'}]">
                    </my-radio>
                </el-form-item>

                <el-form-item
                prop="industrycategory" 
                label="行业分类"
                :rules="newRule('行业分类', 'required')">
                    <!-- form.type == '2' && form.ext3childtype=='1' 表示框架采购协议  该情况下行业分类不包含工程 -->
                    <my-radio
                    v-model="form.industrycategory"
                    :data="(form.type == '2' && form.ext3childtype=='1') ? ([{key:'货物', value:'货物'}, {key:'服务', value:'服务'}]) : ([{key:'货物', value:'货物'}, {key:'工程', value:'工程'}, {key:'服务', value:'服务'}])">
                    </my-radio>
                </el-form-item>

                <el-form-item
                prop="tranmode" 
                label="交易组织形式"
                :rules="newRule('交易组织形式', 'required')">
                    <my-radio
                    v-model="form.tranmode"
                    :data="[{key:'50', value:'集中代理机构组织'}, {key:'51', value:'社会代理机构组织'}, {key:'53', value:'其他组织机构'}]">
                    </my-radio>
                </el-form-item>
               
                <el-form-item
                prop="ispppproject" 
                label="PPP项目"
                :rules="newRule('PPP项目', 'required')">
                    <my-radio
                    v-model="form.ispppproject"
                    :data="[{key:'10', value:'是'}, {key:'20', value:'否'}]">
                    </my-radio>
                </el-form-item>
            </my-form-item-group>

            <my-form-item-group title="采购计划" v-if="form.ext4=='130700'">
                
                <el-form-item 
                label="采购计划名称"
                prop="planname" 
                :rules="newRule('采购计划名称', 'required')">
                    <el-input v-model="form.planname"></el-input>
                </el-form-item>

                <el-form-item 
                label="一级预算部门"
                prop="budgetdepartment" 
                :rules="newRule('一级预算部门', 'required')">
                    <el-input v-model="form.budgetdepartment"></el-input>
                </el-form-item>

                <el-form-item 
                label="采购办办案结束时间"
                prop="shrdate" 
                :rules="newRule('采购办办案结束时间', 'required')">
                    <el-date-picker 
                        v-model="form.shrdate"  
                        type="datetime" 
                        value-format="yyyy-MM-dd HH:mm:ss" 
                        style="width:100%;" >
                    </el-date-picker>
                </el-form-item>

                <el-form-item 
                label="采购计划填写时间"
                prop="operatedate" 
                :rules="newRule('采购计划填写时间', 'required')">
                    <el-date-picker 
                        v-model="form.operatedate"  
                        type="datetime" 
                        value-format="yyyy-MM-dd HH:mm:ss" 
                        style="width:100%;" >
                    </el-date-picker>
                </el-form-item>

                <el-form-item 
                label="审批情况"
                prop="zbfscode" 
                :rules="newRule('审批情况', 'required')">
                    <my-radio
                    v-model="form.shenpitype"
                    :data="shenpiList"
                    2way="value"
                    :value.sync="form.shenpitypename">
                    </my-radio>
                </el-form-item>

                <el-form-item 
                label="是否通过书面推荐方式选择供应商"
                prop="istuijian" 
                :rules="newRule('是否通过书面推荐方式选择供应商', 'required')">
                    <my-radio
                    v-model="form.istuijian"
                    :data="[{key:'1', value:'是'}, {key:'0', value:'否'}]">
                    </my-radio>
                </el-form-item>

            </my-form-item-group>

            <my-form-item-group title="招标信息">
                <el-form-item 
                prop="xmzbrname"
                :rules="newRule('招标人名称', 'required')"
                label="招标人名称">
                    {{form.xmzbrname || '-'}}
                    <!--判断当前登录是否是招标人-->
                    <template v-if="userInfo.identityType=='T'&&userInfo.dwname==form.xmzbrname">
                        <el-button 
                            size="mini" 
                            icon="el-icon-search" 
                            @click="dialogShow" 
                            v-if="form.zbzzxscode!='1'"
                            >
                                选择
                        </el-button>
                    </template>
                    <template v-else>
                        <el-button 
                            size="mini" 
                            icon="el-icon-search" 
                            @click="dialogShow"
                            >
                                选择
                        </el-button>
                    </template>
                    
                </el-form-item>

                <el-form-item 
                prop="xmzbrcode"
                :rules="newRule('招标人统一社会信用代码', 'required')"
                label="招标人统一社会信用代码">
                    {{form.xmzbrcode}}
                </el-form-item>

                <el-form-item 
                prop="e_xmfzr"
                :rules="newRule('招标人联系人', 'required')"
                label="招标人联系人">
                    <el-input v-model="form.e_xmfzr" maxlength="15" show-word-limit></el-input>
                </el-form-item>

                <el-form-item 
                prop="e_fzrphone"
                :rules="newRule('联系人手机号码', 'required','change','mobile')"
                label="联系人手机号码">
                    <el-input v-model="form.e_fzrphone"></el-input>
                </el-form-item>

                <el-form-item
                class="table-full-row"
                v-if="isexist"
                label="关联项目编码">
                    <el-row :gutter="10">
                        <el-col :span="20">
                            <el-input 
                                v-model.trim="form.customcode"
                                placeholder="如需关联“业主项目”，输入需要关联的“关联项目编码”，点击关联进行数据关联">
                            </el-input>
                        </el-col>
                        <el-col :span="4">
                            <el-button 
                            size="mini"
                            icon="el-icon-sort" 
                            type="warning"
                            @click="pullHandler">
                                关联
                        </el-button>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item
                class="table-full-row"
                v-if="projectShow"
                label="选择关联项目">
                    <my-select
                        style="width:50%"
                        v-model="projectname"
                        :clearable="false"
                        :data="glProjectList"
                        :props="{value:'guid',label:'projectname'}"
                        @select="selectPro"
                        placeholder="选择关联项目">
                    </my-select>
                   
                </el-form-item>

                <el-form-item
                prop="zbzzxscode" 
                label="招标组织形式"
                :rules="newRule('招标组织形式', 'required')">
                    <my-radio
                        v-model="form.zbzzxscode"
                        :data="zbzzxsList"
                        2way="value"
                        :value.sync="form.zbzzxsname">
                    </my-radio>
                </el-form-item>

                <el-form-item v-if="form.type == '2' && form.ext3childtype=='1'"
                    prop="cgtype"
                    label="采购形式"
                    :rules="newRule('采购形式', 'required')">
                    <my-radio
                        @select="cgtypeSelect"
                        v-model="form.cgtype"
                        :data="cgtypeList"
                        2way="value"
                        :value.sync="form.cgtypename">
                    </my-radio>
                </el-form-item>
            </my-form-item-group>

            <my-form-item-group title="项目流程设置">
                <!--
                <el-form-item
                    prop="wjhqfs"
                    label="文件下载方式"
                    class="table-full-row"
                    :rules="newRule('文件下载方式', 'required')">
                    <template>
                        <el-radio-group :disabled="wfxz" v-model="form.wjhqfs">
                            <el-radio label="0">非匿名</el-radio>
                            <el-radio label="1">（匿名）公示期下载</el-radio>
                            <el-radio label="2">（匿名）开标前均可下载</el-radio>
                        </el-radio-group>
                    </template>
                    <div v-if="wfxz">
                        <my-tag type="danger">根据监管要求，不允许自主选择文件下载方式，默认选择为匿名下载方式。</my-tag>
                    </div>
                </el-form-item>-->

                <el-form-item
                prop="extsfbm" 
                label="是否需要投标人报名"
                class="table-full-row"
                v-if="sfyxbm==='1'"
                :rules="newRule('是否需要投标人报名', 'required')">
                    <my-radio
                    :disabled="extsfbmDisable"
                    v-model="form.extsfbm"
                    :data="[{key:'1', value:'是'}, {key:'0', value:'否'}]">
                    </my-radio>
                   <!--  <el-radio-group v-model="form.extsfbm">
                        <el-radio :label="1" :disabled="isjy">是</el-radio>
                        <el-radio :label="0" :disabled="isjy">否</el-radio>
                    </el-radio-group>
                    <div v-if="form.wjhqfs != '0'">
                        <my-tag type="danger">根据监管要求，匿名项目不允许设置报名环节。</my-tag>
                    </div>-->
                </el-form-item>

                <el-form-item
                    prop="sftbbzj"
                    label="投标保证金"
                    :rules="newRule('投标保证金', 'required')"
                    :class="{'table-full-row': form.sftbbzj!=='1'}">
                    <my-radio
                        v-model="form.sftbbzj"
                        :data="[{key:'0', value:'否'}, {key:'1', value:'是'}]">
                    </my-radio>
                </el-form-item>

                <el-form-item
                prop="extbzjtype" 
                label="投标担保形式"
                v-if="form.sftbbzj==='1'"
                :rules="newRule('投标担保形式', 'required')">
                    <my-radio
                    v-model="form.extbzjtype"
                    :data="[{key:'0', value:'只保证金'}, {key:'1', value:'只保函'}, {key:'2', value:'保证金或保函'}, {key:'9', value:'其他'}]">
                    </my-radio>
                </el-form-item>

                <!-- 不是邢台不是只保函 -->
                <el-form-item
                prop="by1" 
                label="保证金缴纳账户"
                v-if="form.sftbbzj==='1' && form.extbzjtype!=='1'&&form.ext4!=='130500'"
                :rules="newRule('保证金缴纳账户', 'required')">
                    <my-radio
                        v-model="form.by1"
                        :data="[{key:'0', value:`${ptPlaceholder}平台虚拟账号`}, {key:'1', value:'其他'}]">
                    </my-radio>
                </el-form-item>
                <!-- 不是只保函，是邢台 -->
                <el-form-item
                prop="by1" 
                label="保证金缴纳账户"
                v-if="form.sftbbzj==='1'&&form.extbzjtype!=='1'&&form.ext4==='130500'"
                :rules="newRule('保证金缴纳账户', 'required')">
                    <my-radio
                        v-model="form.by1"
                        :data="[{key:'3', value:'交易中心保证金账号'}, {key:'1', value:'其他'}]">
                    </my-radio>
                </el-form-item>

                <el-form-item
                label="保证金缴纳账户"
                v-if="form.sftbbzj==='1'&&form.extbzjtype==='1'">
                    只保函形式下无保证金账号
                </el-form-item>

                <el-form-item
                    label="保证金缴纳账户"
                    v-if="form.sftbbzj!=='1'">
                    无
                </el-form-item>

                <el-form-item
                prop="nocakey" 
                label="开标环节代理是否使用CA锁解密"
                :rules="newRule('开标环节代理是否使用CA锁解密', 'required')">
                    <my-radio
                    v-model="form.nocakey"
                    :data="[{key:'0', value:'使用'}, {key:'1', value:'不使用'}]">
                    </my-radio>
                </el-form-item>

                <el-form-item
                prop="extzbgj" 
                v-if="form.iszbgj"
                label="是否电子开标评标"
                :rules="newRule('是否电子开标评标', 'required')">
<!--                    <my-radio
                        v-model="form.extzbgj"
                        :data="[{key:'1', value:'是'}, {key:'0', value:'否'}]">
                    </my-radio>-->
                    <el-radio-group v-model="form.extzbgj">
                        <el-radio :label="1" :disabled="izzbgj">是</el-radio>
                        <el-radio :label="0" :disabled="izzbgj">否</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item
                label="附件" class="table-full-row">
                    <my-tag type="danger">只能上传类型为 jpg,zip,rar,pdf,doc,xls,docx 的文件</my-tag>
                    <el-tabs type="card" value="cns">
                        <el-tab-pane label="承诺书" name="cns">
                            <my-projectUpload
                            key="cns"
                            :file-guid="model.fjglbs"
                            :extra="{lx:'承诺书',type:'承诺书', fjtype:'承诺书'}"></my-projectUpload>
                        </el-tab-pane>
                        <el-tab-pane label="采购计划表" name="cgjhb">
                            <my-projectUpload
                            key="cgjhb"
                            :file-guid="model.fjglbs"
                            :extra="{lx:'采购计划表',type:'采购计划表', fjtype:'采购计划表'}"></my-projectUpload>
                        </el-tab-pane>
                        <el-tab-pane label="委托合同" name="wtht">
                            <my-projectUpload
                            key="wtht"
                            :file-guid="model.fjglbs"
                            :extra="{lx:'委托合同',type:'委托合同', fjtype:'委托合同'}"></my-projectUpload>
                        </el-tab-pane>
                        <el-tab-pane label="采购文件首页盖章扫描件" name="cgwjsygzsmj">
                            <my-projectUpload
                            key="cgwjsygzsmj"
                            :file-guid="model.fjglbs"
                            :extra="{lx:'采购文件首页盖章扫描件',type:'采购文件首页盖章扫描件', fjtype:'采购文件首页盖章扫描件'}"></my-projectUpload>
                        </el-tab-pane>
                        <el-tab-pane label="其他" name="qt">
                            <my-projectUpload
                            key="qt"
                            :file-guid="model.fjglbs"
                            :extra="{lx:'其他',type:'其他', fjtype:''}"></my-projectUpload>
                        </el-tab-pane>
                    </el-tabs>
                </el-form-item>
            </my-form-item-group>


            <template slot="btn" slot-scope="scope">
                <el-button
                @click="saveHandler(1, scope.submitHandler)" 
                type="primary" 
                icon="el-icon-circle-check">
                    提交
                </el-button>
                <el-button 
                v-if="isRevision==1"
                @click="saveHandler(2, scope.submitHandler)" 
                type="primary" 
                icon="el-icon-circle-check">
                    提交并创建标段
                </el-button>

                <el-button 
                @click="saveHandler(0, scope.submitHandler)" 
                type="warning" 
                icon="el-icon-remove-outline">
                    暂存
                </el-button>

                <el-button 
                icon="el-icon-circle-close" 
                @click="scope.cancleHandler">
                    取消
                </el-button>
            </template>
        </my-form>

        <my-dialog v-model="dialogVisible">
            <list-zbr
                v-model="form.xmzbrcode"
                2way="name,lxr,tel,orgcode"
                :name.sync="form.xmzbrname"
                :lxr.sync="form.e_xmfzr"
                :tel.sync="form.e_fzrphone"
                :orgcode.sync="form.xmzbrcode"
                @select="dialogClose"
            ></list-zbr>

        </my-dialog>

        <!--藁城交易中心提示-->
        <el-dialog
        title="提示"
        :visible.sync="jyzxdialogVisible"
        width="30%">
        <div>
            <p style="margin-bottom:20px;font-size:16px">
                该交易中心场地有两类，请按项目类别选择适用交易中心，该选择会影响您的后续流程。
            </p>
            <my-radio
            v-model="form.ext5"
            :data="[{key:'J13018201', value:'石家庄市藁城区公共资源交易中心'}, {key:'J13018202', value:'石家庄市藁城区公共资源交易中心(农村产权项目)'}]">
            </my-radio>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="jyzxdialogVisible = false">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_LIST_PAGE from "@views/mixins/dialog-list-page";

import CascaderBdtype from '@views/bidding/components/cascader-bdtype'
import CascaderHy from "@views/bidding/components/cascader-hy";
import ListZbr from '@views/bidding/components/list-zbr'
import myProjectUpload from '@views/bidding/components/my-projectUpload'
export default {
    mixins: [ FORM_PAGE_MIXIN,DIALOG_LIST_PAGE],
    components: {CascaderBdtype ,ListZbr,CascaderHy,myProjectUpload},

    data: () => ({
        form: {
          'zbprocode': '',
          'procode': '',
          'proname': '',
          'zbproname': '',
          'zbnrfasm': '',
          'fjglbs': '',
          'xmzbrcode': '',
          'xmzbrname': '',
          'wtzbrcode': '',
          'wtzbrorgcode': '',
          'wtzbrname': '',
          'zbdljgcode': '',
          'zbdljgorgcode': '',
          'zbdljgname': '',
          'zbfscode': '',
          'zbfsname': '',
          'zbxmjltime': '',
          'jddwcode': '',
          'jddwname': '',
          'shbmcode': '',
          'shbmname': '',
          'ggfwptcode': '',
          'sbzrr': '',
          'zbfirstlb': '',
          'zbsecondlb': '',
          'prouserid': '',
          'prousername': '',
          'extzsfs': '',
          'extdwyjbj': '',
          'ordernum': '',
          'addtime': '',
          'adduserid': '',
          'addusername': '',
          'adduserdeptid': '',
          'adduserdeptname': '',
          'adddwcode': '',
          'adddwname': '',
          'detail': '',
          'shbj': '',
          'scbj': '',
          'createdate': '',
          'modifydate': '',
          'mdiuserid': '',
          'mdiusername': '',
          'mdidwcode': '',
          'mdidwname': '',
          'by1': '',
          'by2': '',
          'by3': '',
          'by4': '',
          'by5': '',
          'e_xmfzr': '',
          'e_fzrtel': '',
          'e_fzremail': '',
          'e_fzrfax': '',
          'e_fzrphone': '',
          'e_xmlxr': '',
          'e_lxrtel': '',
          'e_lxremail': '',
          'e_lxrfax': '',
          'e_lxrphone': '',
          'e_xmjl': '',
          'e_xmjlzz': '',
          'e_lxrtel2': '',
          'e_lxremail2': '',
          'e_lxrfax2': '',
          'e_lxrphone2': '',
          'e_zbfw': '',
          'e_zbgg': '',
          'e_hzdw': '',
          'e_hzsj': '',
          'e_hzwh': '',
          'extsfbm': '0',
          'extzbgj': '',
          'extbzjtype': '',
          'extjiaotong': '',
          'extblackbid': '',
          'ext1': '',
          'ext2': '',
          'ext3': '',
          'ext4': '',
          'ext5': '',
          'extsfbaomi': '',
          'e_xmfzr_zccode': '',
          'e_xmfzr_zcname': '',
          'e_xmfzr_zcdegree': '',
          'e_xmfzr_zcdegreename': '',
          'prousername_zccode': '',
          'prousername_zcname': '',
          'prousername_zcdegreecode': '',
          'prousername_zcdegreename': '',
          'hzproguid': '',
          'nocakey': '',
          'jyzxcitycode': '',
          'jyzxcityname': '',
          'jmpwdbj': '',
          'otherptbm': '',
          'plancode': '',
          'kbycxwsbbj': '',
          'wjhqfs': '',
          'dfrule': '',
          'tender_project_estimate': '',
          'general_contracting': '',
          'construction_estimate': '',
          'cargo_estimate': '',
          'service_estimate': '',
          'pbbgbj': '',
          'dlpstablebj': '',
          'dlpbbgbj': '',
          'govptype': '',
          'extbzjzh': '',
          'jyzxcode': '',
          'jyzxname': '',
          'bmbyca': '',
          'ishbpsp': '',
          'islq_htgsj': '',
          'questiondays': '',
          'fileguid': '',
          'type': '',
          'extstr1': '',
          'extstr2': '',
          'extdate1': '',
          'extdate2': '',
          'extnum1': '',
          'extnum2': '',
          'extint1': '',
          'extint2': '',
          'xtts': '',
          'investtype': '',
          'ispppproject': '',
          'supervisiondepartment': '',
          'approvedepartment': '',
          'industrycategory': '',
          'tranmode': '',
          'microbusinesses': '',
          'jhkgsj': '',
          'jhjgsj': '',
          'xmlb': '',
          'jsdj': '',
          'xmlc': '',
          'gcys': '',
          'procitycode': '',
          'procitydisname': '',
          'prodwname': '',
          'proaddress': '',
          'prohyflcode': '',
          'prohyflname': '',
          'faren': '',
          'lxr': '',
          'lxfs': '',
          'lxfl': '',
          'baspwh': '',
          'baspbm': '',
          'hyfl': '',
          'zjly': '',
          'xmnr': '',
          'xmgm': '',
          'xmztz': '',
          'xmbz': '',
          'e_zdxm': '',
          'e_zbgse': '',
          'e_gytz': '',
          'e_xmgm': '',
          'e_jsnr': '',
          'e_zycp': '',
          'e_jsxz': '',
          'e_jszq': '',
          'e_jzjd': '',
          'e_xmbtel': '',
          'e_website': '',
          'e_fileguid': '',
          'e_jsxzname': '',
          'e_jzjdname': '',
          'xmlbcode': '',
          'xmlbname': '',
          'spxmbh': '',
          'sjly': '',
          'ext_deptcode': '',
          'ext_deptname': '',
          'ext_prolevelcode': '',
          'ext_prolevelname': '',
          'zjdwqk': '',
          'xmlx': '',
          'proxiancode': '',
          'proxianname': '',
          'record_type': '',
          'iszfcg': '',
          'sftbbzj': '',
          'zbzzxscode':'',
          'zbzzxsname':'',
          'customcode':'',
          'shenpitype':'',
          'shenpitypename':'',
          'planname':'',
          'budgetdepartment':'',
          'shrdate':'',
          'operatedate':'',
          'istuijian':'',
          'cgtype':'',
          'cgtypename':'',
          'ext3childtype':'',
          'izyfzb':'',
            'supervisiondepartmentcode':'',
        },
        model:{},
        jyzxList:[],
        shenglist:[],
        sfyxbm:'',
        ptPlaceholder: window._config.title2,
        jyzxdialogVisible:false,
        wfxz:false,
        wjhqfsold:'0',
        isjy:false,
        userInfo:{},//用户信息
        isexist:false,//关联项目编码框是否显示
        projectShow:false,//选择关联项目是否显示
        glProjectList:[],//关联项目列表
        zbzzxsList:[{key:'1', value:'自行招标'}, {key:'2', value:'委托招标'}, {key:'9', value:'其他'}],
        cgtypeList:[{key:'1', value:'封闭式'}, {key:'2', value:'开放式'}],
        projectname:'',
        relation:false,
        shenpiList:[{key:'1', value:'已备案'}, {key:'2', value:'已审批'}, {key:'3', value:'已审核'}],
        izzbgj:false,
        isRevision:0,
        btntype:1,
        extsfbmDisable:false,//在框架协议页面  不允许选择是否需要报名 默认为是
        xtjddw:[],
        jdxx:'',
    }),
    watch: {
        'form.ext4': function(n, o) {
            if(n !== o && o) {
                this.form.ext5 = '';
            };
            if (n === '130500') {
                this.getXtjddw();
            }
        },
        'form.ext5': function(n, o) {
            if(n==='J13018201'){
                this.jyzxdialogVisible = true
            }
            //ext3childtype == 1的时候 是框架协议项目  不需要根据交易中心判断报名 根据采购形式判断
            if(this.getQuery('ext3childtype') != '1'){
                this.$post(`${this.getGetters('mngUrl')}/revision/Zbdl/GovPurchase/getsfyxbm.json`,{
                    jyzxcode:n
                }, (data, res) => {
                    this.sfyxbm = data;
                    if (!this.form.extsfbm) {
                        this.form.extsfbm = '0'
                    }
                });
            }
            
            this.$post(`${this.getGetters('mngUrl')}/Zbdl/ZbProject/sfdown.json`,{
                jyzxcode:n,
                xmlb:'zf',
                tender_project_estimate:this.form.tender_project_estimate,
                construction_estimate:this.form.tender_project_estimate,
            }, (data, res) => {
                if(data){
                    this.form.extsfbaomi = '1';
                }else{
                    this.form.extsfbaomi = '0';
                }
            });
            if (n) {
                this.$post(`${this.getGetters('mngUrl')}/Zbdl/ZbProject/queryWjhqfs.json`, {
                    jyzxcode: n,
                    procode:''
                }, (data, res) => {
                    if (res) {
                        if (res.t.wfxz) {
                            this.form.wjhqfs = res.t.wjhqfs;
                        }
                        else {
                            this.form.wjhqfs = this.wjhqfsold;
                        }
                        this.wfxz = res.t.wfxz;
                    }
                })
            }
        },
        // 招标人弹窗关闭 请求是否需要对接
        'form.xmzbrcode': function(n, o) {
            // 判断是否是编辑 与统一社会信用代码是否有值
            if(n){
                var that = this;
                that.$get(`${this.getGetters('mngUrl')}/tender/isexist.json`,{
                    orgcode:n,
                }, (data, res) => {
                    that.isexist = data;
                    // 编辑获取关联项目信息  判断如果修改招标人没有关联项目清除数据
                    if(that.getQuery('zbprocode')&&that.isexist){
                        // 判断关联项目编码为空不请求
                        if(that.form.customcode){
                            that.pullHandler()
                            that.projectname = that.form.zbproname;
                        }
                        
                    }else{
                        that.projectShow = false;
                        that.form.relationcode = '';
                        that.projectname = '';
                        that.form.customcode = '';
                    }
                });
            }
            
        },
        // 招标组织形式切换
        'form.zbzzxscode': function(n, o) {
            if(n=='1'&&this.userInfo.identityType=='T'){
                this.form.xmzbrname = this.userInfo.dwname;
                this.form.xmzbrcode = this.userInfo.orgcode;
                // this.form.e_xmfzr = '';
                // this.form.e_fzrphone = '';
            }
        },
        'form.e_fzrphone': function(n, o) {
            console.log(n);
            console.log(o);
        },
    },
    methods: {
        //选择采购形式
        cgtypeSelect(val){
            var that = this;
            if(val.key == '2'){
                that.izzbgj = true;
                that.form.extzbgj = 0;
                that.sfyxbm = '1';
                that.form.extsfbm = '1';
                that.extsfbmDisable = true;
            }
            else {
                that.izzbgj = false;
                that.form.extzbgj = 1;
                that.sfyxbm = '0';
            }
        },
        // 获取交易中心数据
        getJyzx(){
            this.$post(`${this.getGetters('mngUrl')}/revision/Zbdl/GovPurchase/getJyzx.json`,{
                by2:this.form.ext4
            }, (data, res) => {
                this.jyzxList = data
            });
            
        },
        // 保存
        saveHandler(type, cb){
            this.form.relationproname = this.projectname
            if(type==2){
                this.form.shbj = 1;
            }else{
                this.form.shbj = type;
            }
            this.btntype = type;
            this.form.type = this.getQuery('type')
            this.form.ext3childtype = this.getQuery('ext3childtype')
            this.form.fjglbs = this.model.fjglbs
            this.form.ishbpsp = '0'
            this.form.childtype = ''
            if(this.form.cgtype == '2') {
                this.form.extsfbm = '1';
            }
            if(this.form.zbfscode == '1') {
                this.form.zbfsname = '公开招标';
            } else if(this.form.zbfscode == '2') {
                this.form.zbfsname = '邀请招标';
            }
            cb && cb();
        },
        // 保存
        fsave(){
            var that = this
            ShowConfirm('请认真核对所填信息！', 'warning', () => {
                that.$post(`${that.getGetters('ageUrl')}/revision/Zbdl/GovPurchase/info.json`,that.form, data => {
                    ShowMsg('保存成功','success')
                    // 关闭当前标签
                    if(getSession('isRevision')==1){
                        window.top.$tagFrame.popTagByIndex(window.top.$tagFrame.getActiveTag().index)
                    }
                //    if(that.userInfo.dwname==that.form.xmzbrname&&this.userInfo.identityType=='T'){
                //   //调权限人员接口
                //   if(data.zbprocode!=null){
                //     that.$post(`${this.getGetters('mngUrl')}/interchange/zbrsystem/permissions.json`,{
                //       zbprocode:data.zbprocode
                //     }, data => {
                //       console.log('权限人员添加成功')
                //     })
                //   }
                //    }
                    // this.goto({
                    //     path: '/bidding/project/zfcg/list',
                    //     query: {
                    //         type: this.getQuery('type'),
                    //     }
                    // });
                    if(that.btntype==2){
                        var pathname = window.location.pathname
                        +'?t='+Math.random()
                        window.top.$tagFrame.pushTag({
                            src:`${pathname}`+'?t='+Math.random()+`#/revision/liucheng/index?id=`+data.by1+'&ext3='+data.ext3+'&add='+1,
                            title:data.zbproname,
                            type: 'href',
                            id:data.by1,
                        })
                        
                    }else{
                        if(getSession('isRevision')!=1){
                            that.$router.go(-1);
                        }
                        
                    }

                    
                }) 
             })
        },
        
        cancleHandler() {
            if(getSession('isRevision')!=1){
                this.$router.go(-1);
            }else{
                // 关闭当前标签
                window.top.$tagFrame.popTagByIndex(window.top.$tagFrame.getActiveTag().index)
            }
        },
        // 选择标段分类 
        hysorname(val){
            this.form.prohyflname = val
        },
        // 获取关联项目信息
        pullHandler(){
            var that = this;
            that.$get(`${that.getGetters('ageUrl')}/tender/project.json`,{
                customcode:that.form.customcode,
                orgcode:that.form.xmzbrcode
            }, data => {
                that.projectname = data[0].projectname
                that.selectPro(data[0])
                ShowMsg('获取关联项目成功','success')
                that.projectShow = true;
                that.glProjectList = data;
            }) 
        },
        // 将选择的项目信息赋值到form
        selectPro(val){        
            console.log(val)
            var that = this;
            that.$get(`${that.getGetters('ageUrl')}/tender/isrelation.json`,{
                relationcode:val.guid,
                customcode:val.customcode,
                zbprocode:that.form.zbprocode
            }, function(data,res) {
                if(data!='200'){
                    ShowMsg(res.msg,'error');
                    that.projectname = '';
                }else{
                    this.relation = true;
                    this.form.relationcode = val.guid;
                    this.form.customcode = val.customcode;
                    // this.form.zbproname = val.projectname;
                    this.zbzzxsList.forEach(function(item){
                        if(item.value==val.zborgtype){
                            that.form.zbzzxscode = item.key;
                        }
                    })
                    if(this.form.industrycategory === null) {
                        this.form.industrycategory = this.glProjectList[0].hyname
                    }
                    
                    that.form.jbzrrcode = val.jbzrrcode;
                    that.form.jbzrrname = val.jbzrrname;
                }
            }) 
            
        },
        getXtjddw(){
            var that = this;
            that.$post(`${this.getGetters('mngUrl')}/third/dock/xingtai/queryJdDwData.json`,{
            }, (data, res) => {
                that.xtjddw = res.tdata;
                if ('200' === res.msg) {
                    that.jdxx = '';
                }
                else {
                    that.jdxx = res.msg;
                }
            });

        },
        jdChange(data) {
            var that = this;
            that.form.supervisiondepartment = data.supervision_Name;
        },
    },
    created() {
        var that = this;
        that.isRevision = getSession('isRevision');
        this.jspInit(`${this.getGetters('ageUrl')}/revision/Zbdl/GovPurchase/queryInfoPageData.json`, {
            type:that.getQuery('type'),
            ext3childtype: this.getQuery('ext3childtype'),
            zbprocode:that.getQuery('zbprocode')
        }, data => {
            var editData = data
            that.model = data
            var form = {}
            form = that.form
            mixin(editData.model, form);
            mixin(editData.extModel, form);
            mixin(editData.pModel, form);
            that.form = form;
            that.form.extzbgj = !!that.form.extzbgj ? Number(that.form.extzbgj) : "";
            if(that.form.extsfbm == '0'){
                that.form.extsfbm = '0';
            }
            else if(that.form.extsfbm == '1'){
                that.form.extsfbm = '1';
            }
            else {
                that.form.extsfbm = '0';
            }
            that.wjhqfsold = form.wjhqfs
            form.type = that.getQuery('type')
            form.ext3childtype = that.getQuery('ext3childtype')

            if (that.form.microbusinesses == null) {
                that.form.microbusinesses = '6';
            }
            that.form.hasmicrobusinesses = '1';
            if(that.form.microbusinesses == '0'){
                that.form.hasmicrobusinesses = '0';
            }
            this.form.iszbgj = data.iszbgj;
            if(that.getQuery('zbprocode')){
                // 编辑
                that.$post(`${this.getGetters('mngUrl')}/revision/Zbdl/GovPurchase/getJyzx.json`,{
                    by2:data.model.ext4
                }, (data, res) => {
                    that.jyzxList = data
                });
                
                
            }
             // 获取Session用户信息
            that.userInfo = getSession('user');
            
            if(that.userInfo.dwname==that.form.xmzbrname&&this.userInfo.identityType=='T'){
                that.$get(`${this.getGetters('mngUrl')}/tree/get_zbrlist.json`,{
                    txtkey:that.form.xmzbrname,  
                    pageindex: 1,
                    sortname: 'addtime',
                    sortorder: 'desc',
                    pagesize: 20,
                    starttime: '',
                    endtime: '',
                }, (data, res) => {
                    if(data.rows.length===1) {
                        that.form.e_xmfzr = data.rows[0].lxr;
                        that.form.e_fzrphone = data.rows[0].tel
                    }
                    
                });
            }
        });
            // 获取Session用户信息
        that.userInfo = getSession('user');
    },
    mounted() {
        
    },
}
</script>

<style scoped lang="scss">
/deep/ .el-radio{ margin-bottom: 10px; }
/deep/ .zjly .el-checkbox{ display: block; }
/deep/ .zjly .el-checkbox-group{ margin-left:0px;}
.zjly {
    position: relative;
}
.zf {
    position: absolute;
    top: 5px;
    left: 110px;
}
.qy {
    position: absolute;
    top: 37px;
    left: 110px;
}
.qt {
    position: absolute;
    top: 69px;
    left: 110px;
}
/deep/ .zjly .el-checkbox {
    width: 100px;
}
</style>

 
